//Remove replace :focus outline cased on https://hackernoon.com/removing-that-ugly-focus-ring-and-keeping-it-too-6c8727fefcd2

function tabHandler() {

    function handleFirstTab(e) {
      if (e.keyCode === 9) {
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
      }
    }
  
    window.addEventListener('keydown', handleFirstTab);
  
  };
  
  window.addEventListener('keydown', tabHandler);